import Image from "next/image";
import { SidebarLinkItem } from "../../SidebarLink";
import { ChevronDown } from "lucide-react";

export const SidebarItem = ({
  parent,
  unitStatus,
  arrow = false,
  active = false,
}: {
  parent: SidebarLinkItem;
  unitStatus?: boolean;
  arrow?: boolean;
  active?: boolean;
}) => {
  return (
    <div
      className={`flex w-full items-center justify-between gap-2 capitalize font-semibold ${
        active ? "text-white" : "text-slate-500"
      }`}
    >
      <div className="flex min-w-0 items-center gap-3">
        {parent?.icon && (
          <parent.icon
            size={20}
            className={`shrink-0 ${active ? "text-white" : "text-slate-400"}`}
          />
        )}
        {parent?.image && (
          <Image
            src={
              active && parent?.imageFill
                ? parent?.imageFill
                : parent?.image
            }
            alt={parent?.label}
            width={21}
            height={21}
            className={`h-[21px] w-[21px] shrink-0 object-contain ${
              active ? "brightness-0 invert" : "opacity-70"
            }`}
          />
        )}
        <p className="truncate text-sm">{parent?.label}</p>
      </div>

      {arrow && (
        <div
          className={`h-fit w-fit transform transition-transform duration-300 ${
            unitStatus ? "rotate-180" : ""
          }`}
        >
          <ChevronDown className="h-4 w-4" />
        </div>
      )}
    </div>
  );
};
